import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import WidgetStatePlaceholder from '../../../components/WidgetStatePlaceholder';
import { mapActivityListData } from './utils/activityListDataMapper';
import ActivityListItem from './components/ActivityListItem';
import { ACTIVITY_STATE_COPY } from './constants';

/**
 * Activity List widget - Last Activity per Figma (WID-02 to WID-05).
 * Expanded: full content. Compressed: icon, title, alert, time ago.
 * States: no connection, system error, empty (no CTA in empty per WID-05).
 */
const ActivityListWidgetInner = ({
  data = null,
  isCompressed = false,
  error = null,
  errorCode = '',
  onRetry = undefined,
  canRetry = true,
  onItemClick = undefined,
}) => {
  const mappedData = useMemo(
    () => mapActivityListData(data),
    [data],
  );

  const handleItemClick = useCallback(
    (item) => {
      onItemClick?.(item);
    },
    [onItemClick],
  );

  if (error) {
    return (
      <WidgetStatePlaceholder
        error={error}
        errorCode={errorCode}
        stateCopy={ACTIVITY_STATE_COPY}
        onRetry={onRetry}
        canRetry={canRetry}
      />
    );
  }

  if (!mappedData.items?.length) {
    return (
      <WidgetStatePlaceholder
        isEmpty
        stateCopy={ACTIVITY_STATE_COPY}
      />
    );
  }

  return (
    <div className="flex flex-col gap-2 w-full">
      {mappedData.items.map((item) => (
        <ActivityListItem
          key={item.id}
          item={item}
          isCompressed={isCompressed}
          onItemClick={handleItemClick}
        />
      ))}
    </div>
  );
};

ActivityListWidgetInner.propTypes = {
  data: PropTypes.object,
  isCompressed: PropTypes.bool,
  error: PropTypes.object,
  errorCode: PropTypes.string,
  onRetry: PropTypes.func,
  canRetry: PropTypes.bool,
  onItemClick: PropTypes.func,
};


const ActivityListWidget = React.memo(ActivityListWidgetInner);

export default ActivityListWidget;
